export const GENERIC_API_ERROR = 'Signup/Api/GENERIC_API_ERROR';
export const baseUrl = AUTHENTICATION_API;
export const apiGatewayBaseUrl = TEAMLEADER_API;
export const signupAccessTokenFetchUrl = SIGNUP_ACCESS_TOKEN_API;
export const signupApiUrl = SIGNUP_API;
export const referralApiUrl = REFERRAL_API;
export const authenticationServiceUrl = AUTHENTICATION_SERVICE_URL;
